<i18n>
{
	"en": {
		"confirmDeleteSubOrder": "Are you sure you want to remove the selected stretch?"
	},
	"no": {
		"confirmDeleteSubOrder": "Er du sikker på at du vil fjerne den valgte strekning?"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="$emit('confirm')"
		@close="$emit('close')"
	>
		{{$t('confirmDeleteSubOrder')}}
	</t-dialog>
</template>

<script>
export default {
	name: 'ConfirmDeleteSubOrder',
	props: {
		isShown: Boolean,
	},
};
</script>
